export default [{
  id: 'search',
  label: 'Search',
  to: '/',
  isActive: (match, location) => {
    if (!location) return false
    return location.pathname === '/'
  }
}]
